import { useCallback } from 'react';

interface AutocompleteBlurProps {
    isSmallScreen: boolean;
    getSelectedIndex: () => number;
    selectCurrentOption: () => void;
    setShowDropdown: (open: boolean) => void;
}

export function useAutocompleteBlur({ isSmallScreen, getSelectedIndex, selectCurrentOption, setShowDropdown }: AutocompleteBlurProps) {
    return useCallback(() => {
        if (!isSmallScreen) {
            setShowDropdown(false);

            if (getSelectedIndex() !== -1) {
                selectCurrentOption();
            }
        }
    }, [isSmallScreen, getSelectedIndex, selectCurrentOption, setShowDropdown]);
}
